import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, createQueryKey, useAxiosClient, useMutation, useQuery } from '@lumahealthhq/ui-model';
import { EModel } from '@lumahealthhq/ui-model-types';
import { getFieldModelId, getModelBasePath } from '@lumahealthhq/ui-utils';
import { EPatientJourneyDateRangeOptions } from '../../ui-model-types';
var basePath = 'patient-journey';
var crud = createCrud(basePath);

/* Default queries */
export var usePatientJourneyCount = crud.makeCount();
export var usePatientJourneyById = crud.makeFindById();
export var usePatientJourneyByIds = crud.makeFindByIds();
export var usePatientJourneyMany = crud.makeFindMany();
export var usePatientJourneyOne = crud.makeFindOne();
export var usePatientJourneyPagination = crud.makePagination();

/* Default mutations */
export var usePatientJourneyCreateOne = crud.makeCreateOne();
export var usePatientJourneyUpdateOne = crud.makeUpdateOne();
export var usePatientJourneyRemoveById = crud.makeRemoveById();
export function usePatientJourneyBuilder(payload, options) {
  var axiosClient = useAxiosClient();
  var url = "v2/".concat(basePath, "/builder");
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$axiosClient$po, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.post(url, payload);
          case 2:
            _yield$axiosClient$po = _context.sent;
            data = _yield$axiosClient$po.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, url);
  return useQuery(queryKey, queryFn, options);
}
export function usePatientJourneyBuildWorkflow(options) {
  var axiosClient = useAxiosClient();
  var url = "v2/".concat(basePath, "/builder");
  function mutationFn(_x) {
    return _mutationFn.apply(this, arguments);
  }
  function _mutationFn() {
    _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(followupWorkflowId) {
      var _yield$axiosClient$ge, followupWorkflow, followupId, _yield$axiosClient$ge2, followup, limit, payload, _yield$axiosClient$po2, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axiosClient.get("v2/".concat(getModelBasePath(EModel.FollowupWorkflow), "/").concat(followupWorkflowId), {
              params: {
                _select: 'followups.followup'
              }
            });
          case 2:
            _yield$axiosClient$ge = _context2.sent;
            followupWorkflow = _yield$axiosClient$ge.data;
            followupId = getFieldModelId(followupWorkflow.followups.followup);
            _context2.next = 7;
            return axiosClient.get("v2/".concat(getModelBasePath(EModel.Followup), "/").concat(followupId), {
              params: {
                _select: 'model'
              }
            });
          case 7:
            _yield$axiosClient$ge2 = _context2.sent;
            followup = _yield$axiosClient$ge2.data;
            limit = 7;
            payload = {
              steps: [{
                position: 1,
                events: [{
                  eventName: followup.model
                }],
                hiddenEvents: [],
                limit: limit
              }, {
                position: 2,
                events: [],
                hiddenEvents: [],
                limit: limit
              }, {
                position: 3,
                events: [],
                hiddenEvents: [],
                limit: limit
              }, {
                position: 4,
                events: [],
                hiddenEvents: [],
                limit: limit
              }],
              filters: {
                followupWorkflows: [followupWorkflow._id],
                dateRange: {
                  range: EPatientJourneyDateRangeOptions.lastWeek
                }
              }
            };
            _context2.next = 13;
            return axiosClient.post(url, payload);
          case 13:
            _yield$axiosClient$po2 = _context2.sent;
            data = _yield$axiosClient$po2.data;
            return _context2.abrupt("return", data);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _mutationFn.apply(this, arguments);
  }
  return useMutation([], mutationFn, options);
}